/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { EcdsaSecp256K1VerificationKey2019Type } from './EcdsaSecp256K1VerificationKey2019Type';

export const EcdsaSecp256K1VerificationKey2019: core.serialization.ObjectSchema<
    serializers.EcdsaSecp256K1VerificationKey2019.Raw,
    Truvity.EcdsaSecp256K1VerificationKey2019
> = core.serialization.object({
    context: core.serialization.property('@context', core.serialization.list(core.serialization.string()).optional()),
    controller: core.serialization.string(),
    id: core.serialization.string(),
    publicKeyBase58: core.serialization.string(),
    type: EcdsaSecp256K1VerificationKey2019Type,
});

export declare namespace EcdsaSecp256K1VerificationKey2019 {
    export interface Raw {
        '@context'?: string[] | null;
        controller: string;
        id: string;
        publicKeyBase58: string;
        type: EcdsaSecp256K1VerificationKey2019Type.Raw;
    }
}
